import styles from './PolicyPreviewButton.module.scss';
import arrowIcon from './resources/arrow_icon.svg';

export const PolicyPreviewButton = ({ policyNumber }: { policyNumber: string }) => {
	return (
		<button className={styles.PolicyPreviewButton__button}>
			{policyNumber}
			<img
				src={arrowIcon}
				alt='Arrow Icon'
			/>
		</button>
	);
};
